import { render, staticRenderFns } from "./SBHealthPlans.vue?vue&type=template&id=3f854032"
import script from "./SBHealthPlans.vue?vue&type=script&lang=js"
export * from "./SBHealthPlans.vue?vue&type=script&lang=js"
import style0 from "./SBHealthPlans.vue?vue&type=style&index=0&id=3f854032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports